/* eslint-disable react/no-danger */
import React from 'react';

import {
  Grid,

  Divider,
  Button,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import classes from '../../../css/getCSS';
import * as routes from '../../../config/routes';


const activityListItem = (props) => {
  let activityLink = null;
  let openText = null;

  if (props.content_type === 'message') {
    activityLink = formatRoute(routes.ACTIVITIES, { type: 'messages' });
    openText = 'View All Messages';
  }

  let extraData = null;
  if (props.content_type === 'message') {
    extraData = (
      <React.Fragment>
        <br />
        <blockquote className={classes.profileFormQuote}>
          <div dangerouslySetInnerHTML={{ __html: props.activity.message }} />
        </blockquote>
        <br />
      </React.Fragment>
    );
  }


  return (
    <React.Fragment>
      {extraData}
      <Divider />
      <Grid container>
        <Grid item md={6} sm={6} xs={6} align="center" className={classes.padding10}>
          <Link className={classes.linkDeCSS} to={activityLink} target="_blank">
            <Button variant="flat" color="default" size="small">{openText}</Button>
          </Link>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default activityListItem;



// WEBPACK FOOTER //
// ./src/dashboard/components/activities/MessageListItem.js